import { BaseApi } from './base';

class StudyingSubjectsApi extends BaseApi {
  constructor() {
    super('admin/program/subjects');
  }

  getSubjects() {
    return this.get('')
  }

  createOrUpdateSubject(data) {
    return this.post('', data)
  }

  removeSubject(id) {
   return this.delete(`/${id}`)
  }
}

export default new StudyingSubjectsApi();
